module.exports = __webpack_public_path__ + "img/teams.9273bba0.svg";